import { jsx as o } from "react/jsx-runtime";
import { noop as e } from "es-toolkit/function";
import t from "../button/Button.js";
const l = ({ onClick: r = e }) => /* @__PURE__ */ o(t, { bsStyle: t.MUTED, iconOnly: !0, onClick: r, "data-testid": "sidebarCloseButton", children: /* @__PURE__ */ o("span", { className: "rioglyph rioglyph-remove" }) });
export {
  l as default
};
//# sourceMappingURL=SidebarCloseButton.js.map
